import { CUBE_AGGREGATE_INTERACTION, CUBE_WEBSITE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfig } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { WEBSITE_PORTAL_FILTER_LIMIT } from '../../filterDefaultLimits';

const WEBSITE_PORTAL_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.website_name`],
    limit: WEBSITE_PORTAL_FILTER_LIMIT,
    timeDimensions: [timeDimensions],
  };
  return query;
};

const websitePortalFilter: FilterConfig = {
  searchable: true,
  label: 'main.channelFocus.hcpCoverage.filters.websitePortal.label',
  placeholder: 'main.channelFocus.hcpCoverage.filters.websitePortal.placeholder',
  clearable: true,
  type: 'multiselect',
  defaultValue: [],
  getOptionsQuery: WEBSITE_PORTAL_OPTIONS,
  sourceCube: CUBE_WEBSITE_AGGREGATE_INTERACTION,
  mapResult: mapDimensionToOption(`${CUBE_WEBSITE_AGGREGATE_INTERACTION}.website_name`),
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${CUBE_WEBSITE_AGGREGATE_INTERACTION}.website_name`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default websitePortalFilter;
